import { buildClient } from '@octopus-do/octopus-api-client'

// Nest reads the same `X-Auth-Token` the PHP API and sync do. The token is
// looked up per request rather than once: the client is built at import time,
// before anyone has logged in.
const authFetch: typeof fetch = (input, init) => {
  const token = localStorage.getItem('token')
  const headers = new Headers(init?.headers)

  if (token) {
    headers.set('X-Auth-Token', token)
  }

  return fetch(input, { ...init, headers })
}

export const NestClient = buildClient({
  fetch: authFetch,
  host: import.meta.env.VITE_NEST_URL,
})

// A Nest route the published client does not bind yet, called with the same
// token and host. JSON in, JSON out; a non-2xx answer is thrown as an Error
// with the status, the way the client's HttpError carries it.
export const fetchNest = async <T>(
  path: string,
  init: RequestInit = {}
): Promise<T> => {
  const response = await authFetch(`${import.meta.env.VITE_NEST_URL}${path}`, {
    ...init,
    headers: { 'Content-Type': 'application/json', ...init.headers },
  })

  if (!response.ok) {
    throw new Error(`Nest ${init.method ?? 'GET'} ${path}: ${response.status}`)
  }

  const text = await response.text()

  return (text ? JSON.parse(text) : undefined) as T
}
